import Pagination from '@/domain/pagination.entity';
import CalculationResult from '@/domain/calculation/entity/calculation-result.entity';
import axios from 'axios';
import ScriptFilter from '../entity/rule-script-filter.entity';
import Response from '../../response.entity';
import RuleScript from '../entity/rule-script.entity';
import RuleSimulateScriptRequest from '../entity/rule-simulate-script-request';

export default class RuleScriptService {
  public static filterRules(
    pagination: Pagination, businessUnitId: string, filter: ScriptFilter,
  ): Promise<Response> {
    return axios.get(`/api/v1/business-units/${businessUnitId}/rules/filter`, {
      params: {
        page: pagination.page - 1,
        size: pagination.itemsPerPage,
        name: filter.name,
        status: filter.status || null,
      },
    }).then((response: any) => Response.of(response.data))
  }

  public static approveRule(businessUnitId: string, ruleId: string): Promise<void> {
    return axios.put(`/api/v1/business-units/${businessUnitId}/rules/${ruleId}/approval`)
  }

  public static deleteRule(businessUnitId: string, ruleId: string): Promise<void> {
    return axios.delete(`/api/v1/business-units/${businessUnitId}/rules/${ruleId}`)
  }

  public static getRule(businessUnitId: string, ruleId: string): Promise<RuleScript> {
    return axios.get(`/api/v1/business-units/${businessUnitId}/rules/${ruleId}`)
      .then((response: any) => RuleScript.of(response.data))
  }

  public static saveNewRuleScript(
    businessUnitId: string, ruleScript: RuleScript,
  ): Promise<RuleScript> {
    return axios.post(`/api/v1/business-units/${businessUnitId}/rules`, ruleScript)
      .then((response: any) => RuleScript.of(response.data))
  }

  public static updateRuleScript(
    businessUnitId: string, ruleScript: RuleScript,
  ): Promise<RuleScript> {
    return axios.put(`/api/v1/business-units/${businessUnitId}/rules/${ruleScript.id}`, ruleScript)
      .then((response: any) => RuleScript.of(response.data))
  }

  public static simulateRuleScript(
    businessUnitId: string, ruleScript: RuleSimulateScriptRequest,
  ): Promise<CalculationResult> {
    return axios.post(`/api/v1/business-units/${businessUnitId}/rules/simulation`, ruleScript)
      .then((response: any) => CalculationResult.of(response.data))
  }
}
